"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "renon": {
    "a3589b4d": [{
      "hkey": "ee653a85",
      "slug": "renon",
      "name": "Renon",
      "primary": true,
      "skipSearch": false
    }],
    "castel-novale": [{
      "hkey": "ee653a85",
      "slug": "renon",
      "name": "Renon",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6ed60279": [{
      "hkey": "ee653a85",
      "slug": "renon",
      "name": "Renon",
      "primary": true,
      "skipSearch": false
    }],
    "madonnina": [{
      "hkey": "ee653a85",
      "slug": "renon",
      "name": "Renon",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "488b2a9c": [{
      "hkey": "ee653a85",
      "slug": "renon",
      "name": "Renon",
      "primary": true,
      "skipSearch": false
    }],
    "monte-di-mezzo": [{
      "hkey": "ee653a85",
      "slug": "renon",
      "name": "Renon",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "38d7a46e": [{
      "hkey": "ee653a85",
      "slug": "renon",
      "name": "Renon",
      "primary": true,
      "skipSearch": false
    }],
    "pietrarossa": [{
      "hkey": "ee653a85",
      "slug": "renon",
      "name": "Renon",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;